import { NotificationService } from './../../../services/notification.service';
import { TaxonomyService } from './../../../services/taxonomy.service';
import { TaxonomyApiService } from './../../../services/api-services/taxonomy-api.service';
import { Component } from '@angular/core';
import { ButtonComponent } from "../../../components/button/button.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-taxonomy-actions',
  standalone: true,
  imports: [ButtonComponent, CommonModule],
  templateUrl: './taxonomy-actions.component.html',
  styleUrl: './taxonomy-actions.component.scss'
})
export class TaxonomyActionsComponent {

  taxonomyId: string = this.taxonomyService.selectedTaxonomy?.taxonomy_id;
  taxonomyName: string = this.taxonomyService.selectedTaxonomy?.taxonomy_name;

  constructor(private taxonomyApiService: TaxonomyApiService,
    private taxonomyService: TaxonomyService,
    public notificationService: NotificationService
  ){

  }

  publishAction() {
    const body = {
      taxonomy_id: this.taxonomyId
    }

    this.taxonomyApiService.publishTaxonomyV2(body).subscribe({
      next: (res) => {
        this.notificationService.success(
          'publish taxonomy', 'Taxonomy published'
        )
      },
      error: (err) => {
        console.error('Failed to fetch taxonomy', err);
        this.notificationService.error(
          'publish taxonomy', 'Taxonomy failed to published'
        )
      },
    });
  }

  saveAsDraftAction(){
  }
}
